import React from 'react';
export function ContactHero() {
  return <div className="text-center mb-12" data-id="element-273">
      <h1 className="text-4xl md:text-5xl font-bold text-ink mb-6 load-fade-in-up stagger-1" data-id="element-274">
        Let's Discuss Your Project
      </h1>
      <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto load-fade-in-up stagger-2" data-id="element-275">
        We accept new clients by referral to ensure the best fit and maintain
        our commitment to quality. If a trusted partner or colleague recommended
        Magnus Software, we're ready to discuss your project.
      </p>
    </div>;
}